import {
    put,
    call,
    all,
    fork,
    takeEvery,
} from "redux-saga/effects"

import { GET_ACCESSPROFILE_START, CREATE_ACCESSPROFILE_START ,GET_ROUTES_START, ASSIGN_ROUTES_START,GET_EMPROUTES_START, GET_ACCESSEMPLOYEE_START, UPDATE_ACCESSPROFILE_START, GET_OTHER_ROUTES, UPDATE_OTHER_ROUTES, GETMY_OTHER_ROUTES} from "./actionTypes"

import { 
    createAccessProfileSuccess, 
    createAccessProfileFailure,
    GetAccessProfileSuccess, 
    GetAccessProfileFailure,
    GetRoutesSuccess,
    GetRoutesFailure,
    assignRoutesFailure,
    assignRoutesSuccess, 
    GetEmpRoutesFailure,
    GetEmpRoutesSuccess,
    GetAccessEmployeeSuccess,
    GetAccessEmployeeFailure,
    updateAccessProfileSuccess,
    updateAccessProfileFailure,
    getAccessOtherRoutesSuccess,
    getAccessOtherRoutesFailed,
    updateAccessOtherRoutesSuccess,
    updateAccessOtherRoutesFailed,
    getMyAccessOtherRoutesSuccess,
    getMyAccessOtherRoutesFailed,

} from "./action"

import { assignRoutesAPI, createAccessProfileAPI, getAccessEmployeeAPI, getAccessOtherRoutesAPI, getAccessProfileAPI, getEmpRoutesAPI, getMyAccessOtherRoutesAPI, getRoutesAPI, updateAccessOtherRoutesAPI, updateAccessProfileAPI } from "./api"

// CREATE Profile for access

function* createAccessprofileAsync( payload ) {
    try {
        const response = yield call(createAccessProfileAPI, payload.payload)
        console.log(payload)
        if (response.status === 200) {
            yield put(createAccessProfileSuccess(response))
        } else {
            throw response
        }
    } catch (error) {
        yield put(createAccessProfileFailure(error))
    }
}

function* createAccessProfile() {
    yield takeEvery(CREATE_ACCESSPROFILE_START, createAccessprofileAsync)
}


// to get access profiles
function* getAccessProfileAsync() {
    try {
        const response = yield call(getAccessProfileAPI)

        if (response.status === 200) {
            yield put(GetAccessProfileSuccess(response.data))
        } else {
            
            yield put(GetAccessProfileFailure(response.message))
        }
    } catch (error) {

        yield put(GetAccessProfileFailure(error.response.data))
    }
}


function* getAccessProfile() {
    yield takeEvery(GET_ACCESSPROFILE_START, getAccessProfileAsync)
}


// to get routes

function* getRoutesAsync  (){
    try {
        const response = yield call(getRoutesAPI)

        if (response.status === 200) {
            yield put(GetRoutesSuccess(response.data))
        } else {
            
            yield put(GetRoutesFailure(response.message))
        }
    } catch (error) {

        yield put(GetRoutesFailure(error.response))
    }
}


function* getRoutes() {
    yield takeEvery(GET_ROUTES_START, getRoutesAsync)
}


// to assign profiles to employye

function* assignRoutesAsync( payload ) {
    try {
        const response = yield call(assignRoutesAPI, payload.payload)
        console.log(payload)
        if (response.status === 200) {
            yield put(assignRoutesSuccess(response))
        } else {
            throw response
        }
    } catch (error) {
        yield put(assignRoutesFailure(error))
    }
}

function* assignRoutes() {
    yield takeEvery(ASSIGN_ROUTES_START, assignRoutesAsync)
}




// to get Assined routes

function* getEmpRoutesAsync  (payload){
    try {
        const response = yield call(getEmpRoutesAPI,payload.payload)

        if (response.status === 200) {
            yield put(GetEmpRoutesSuccess(response.data))
        } else {
            
            yield put(GetEmpRoutesFailure(response.message))
        }
    } catch (error) {

        yield put(GetEmpRoutesFailure(error.response))
    }
}


function* getEmpRoutes() {
    yield takeEvery(GET_EMPROUTES_START, getEmpRoutesAsync)
}

// to get employee for access

function* getAccessEmployeeAsync  (){
    try {
        const response = yield call(getAccessEmployeeAPI)

        if (response.status === 200) {
            yield put(GetAccessEmployeeSuccess(response.data))
        } else {
            
            yield put(GetAccessEmployeeFailure(response.message))
        }
    } catch (error) {

        yield put(GetAccessEmployeeFailure(error.response))
    }
}


function* getAccessEmployee() {
    yield takeEvery(GET_ACCESSEMPLOYEE_START, getAccessEmployeeAsync)
}



function* updateAccessProfileAsync(payload){
    try {
        const response = yield call(updateAccessProfileAPI, payload.payload)

        if (response.status === 200) {
            console.log(response)
            yield put(updateAccessProfileSuccess(response.data))
        } else {
            
            yield put(updateAccessProfileFailure(response.data))
        }
    } catch (error) {

        yield put(updateAccessProfileFailure(error.response.data))
    }
}


function* updateAccessProfile() {
    yield takeEvery(UPDATE_ACCESSPROFILE_START, updateAccessProfileAsync)
}



function* getOtherRoutesAsync(){
    try {
        const response = yield call(getAccessOtherRoutesAPI)

        if (response.status === 200) {
            console.log(response)
            yield put(getAccessOtherRoutesSuccess(response.data))
        } else {
            
            yield put(getAccessOtherRoutesFailed(response.data))
        }
    } catch (error) {

        yield put(getAccessOtherRoutesFailed(error.response.data.message || "Error occured"))
    }
}


function* getAccessOtherRoutesSaga() {
    yield takeEvery(GET_OTHER_ROUTES, getOtherRoutesAsync)
}



function* updateOtherRoutesAsync(action){
    try {
        const response = yield call(updateAccessOtherRoutesAPI, action.payload)

        if (response.status === 200) {
            console.log(response)
            yield put(updateAccessOtherRoutesSuccess(response.data))
        } else {
            
            yield put(updateAccessOtherRoutesFailed(response.data|| "Error occured"))
        }
    } catch (error) {

        yield put(updateAccessOtherRoutesFailed(error.response.data.message || "Error occured"))
    }
}


function* updateAccessOtherRoutesSaga() {
    yield takeEvery(UPDATE_OTHER_ROUTES, updateOtherRoutesAsync)
}



function* getMyOtherRoutesAsync(action){
    try {
        const response = yield call(getMyAccessOtherRoutesAPI, action.payload)

        if (response.status === 200) {
            console.warn(response.data)
            yield put(getMyAccessOtherRoutesSuccess(response.data.Assigned_Routes))
        } else {
            
            yield put(getMyAccessOtherRoutesFailed(error.response.data.message || "Error occured"))
        }
    } catch (error) {

        yield put(getMyAccessOtherRoutesFailed(error.response.data.message || "Error occured"))
    }
}


function* getMyAccessOtherRoutesSaga() {
    yield takeEvery(GETMY_OTHER_ROUTES, getMyOtherRoutesAsync)
}

function* AccessProfileSaga() {
    yield all([

        fork(createAccessProfile),
        fork(getAccessProfile),
        fork(getRoutes),
        fork(assignRoutes),
        fork(getEmpRoutes),
        fork(getAccessEmployee),
        fork(updateAccessProfile),
        fork(getAccessOtherRoutesSaga),
        fork(updateAccessOtherRoutesSaga),
        fork(getMyAccessOtherRoutesSaga),
    ])
}

export default AccessProfileSaga
